import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  Text,
  useToast,
  Link,
  Alert,
  AlertIcon,
  Heading,
} from '@chakra-ui/react';
import {
  getPasswordResetErrorMessage,
  requestPasswordReset,
} from '../../services/authService';

const ForgotPasswordForm: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const toast = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      await requestPasswordReset(email);
      setSent(true);
      toast({
        title: 'Correo enviado',
        description: 'Revisa tu bandeja de entrada para restablecer tu contraseña.',
        status: 'success',
        duration: 5000,
      });
    } catch (error) {
      toast({
        title: 'No se pudo enviar el correo',
        description: getPasswordResetErrorMessage(error),
        status: 'error',
        duration: 5000,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box maxW="md" mx="auto" mt={8}>
      <Heading size="md" mb={2} textAlign="center">
        Recuperar contraseña
      </Heading>
      <Text mb={6} textAlign="center" color="gray.600" fontSize="sm">
        Te enviaremos un enlace a tu correo para crear una nueva contraseña.
      </Text>

      {sent ? (
        <VStack spacing={4} align="stretch">
          <Alert status="success" borderRadius="md">
            <AlertIcon />
            Si existe una cuenta con <strong>{email}</strong>, recibirás un correo con
            instrucciones en los próximos minutos. Revisa también spam o correo no deseado.
          </Alert>
          <Button as={RouterLink} to="/login" colorScheme="pitch" width="full">
            Volver a iniciar sesión
          </Button>
          <Button
            variant="ghost"
            width="full"
            onClick={() => {
              setSent(false);
              setEmail('');
            }}
          >
            Enviar a otro correo
          </Button>
        </VStack>
      ) : (
        <form onSubmit={handleSubmit}>
          <VStack spacing={4}>
            <FormControl isRequired>
              <FormLabel>Correo electrónico</FormLabel>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="tu@email.com"
                autoComplete="email"
              />
            </FormControl>
            <Button
              type="submit"
              colorScheme="pitch"
              width="full"
              isLoading={loading}
            >
              Enviar enlace de recuperación
            </Button>
            <Text fontSize="sm">
              <Link as={RouterLink} to="/login" color="pitch.500">
                ← Volver a iniciar sesión
              </Link>
            </Text>
          </VStack>
        </form>
      )}
    </Box>
  );
};

export default ForgotPasswordForm;
